// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrows__wrapper___A2Ean","right":"Arrows__right___-UfmY","left":"Arrows__left___fX6Dv"};